import moment from 'moment';
import methodOptions from '../options/method';

const phase3Fields = {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'The Reward Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  description: {
    value: '',
    error: null,
    name: 'description',
    placeholder: 'Description for Customer',
    breed: 'textarea',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'textarea',
  },
  cashier_directions: {
    value: '',
    error: null,
    name: 'cashier_directions',
    placeholder: 'Cashier Directions',
    breed: 'textarea',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'textarea',
  },
  point_value: {
    value: 0,
    error: null,
    name: 'point_value',
    placeholder: 'Coins Required',
    breed: 'points',
    touched: false,
    isRequired: true,
    validationType: 'number',
    hasBlurred: false,
    inputType: 'text',
  },
  start_date: {
    value: moment().format('MM/DD/YY'),
    error: null,
    name: 'start_date',
    placeholder: 'Start Date',
    breed: 'date',
    touched: true,
    isRequired: false,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  end_date: {
    value: moment().format('MM/DD/YY'),
    error: null,
    name: 'end_date',
    placeholder: 'Expiration Date',
    breed: 'date',
    touched: true,
    isRequired: false,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  }
}

export default phase3Fields;



/** WEBPACK FOOTER **
 ** ./src/forms/campaign/createPhase3.js
 **/